import uuid from 'uuidv4';

const getSubscriptionsWindow = (WINDOW = window) => {
  for (const key of Object.keys(WINDOW)) {
    const prefix = String(WINDOW.location);

    if (key.includes(prefix)) {
      const keyId = key.replace(prefix, '');
      const getId = WINDOW[key][keyId];

      const id = typeof getId === 'function' ? getId(true) : '.';

      if (keyId === id) {
        return WINDOW[key][id]();
      }
    }
  }

  if (WINDOW === WINDOW.parent) {
    return;
  }

  return getSubscriptionsWindow((WINDOW as any).parent);
};

const getSubscriptions = (window = null) => {
  if (window) {
    const id = uuid();
    const _ = {};

    window[`${String(window.location)}${id}`] = {
      [id]($) {
        return $ ? id : _;
      },
    };
  }

  return getSubscriptionsWindow();
};

export default getSubscriptions;
